module.exports = "<div class=\"errorPage\">\r\n    <div ng-bind-html=\"errorPageContent\" ng-if=\"!message\"></div>\r\n    <div ng-if=\"message\">{{message}}</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/errorpage/errorpage.directive.html
// module id = 205
// module chunks = 1